"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractMeasureReportBuilder = void 0;
class AbstractMeasureReportBuilder {
    constructor(measure, options) {
        this.measure = measure;
        this.options = options;
    }
    addEvaluatedResources(result) {
        if (result.evaluatedResource) {
            result.evaluatedResource.forEach(resource => {
                var _a;
                const reference = {
                    reference: `${resource.resourceType}/${resource.id}`
                };
                if (!((_a = this.report.evaluatedResource) === null || _a === void 0 ? void 0 : _a.some(r => r.reference === reference.reference))) {
                    if (!this.report.evaluatedResource) {
                        this.report.evaluatedResource = [reference];
                    }
                    else {
                        this.report.evaluatedResource.push(reference);
                    }
                }
            });
        }
    }
}
exports.AbstractMeasureReportBuilder = AbstractMeasureReportBuilder;
//# sourceMappingURL=AbstractMeasureReportBuilder.js.map